export const getSortState = function (locationSearch, itemsPerPage, idField) {
  const params = new URLSearchParams(locationSearch);
  const pageParam = params.get("page");
  const sortParam = params.get("sort");
  let sort = idField || "id";
  let order = "asc";
  let activePage = 1;
  if (pageParam) {
    activePage = parseInt(pageParam, 10);
  }
  if (sortParam) {
    sort = sortParam?.split(",")[0];
    order = sortParam?.split(",")[1];
  }
  return { itemsPerPage, sort, order, activePage };
};
